"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionNotSupportedError = exports.ServiceUnavaliableError = exports.NotImplementedError = exports.NetworkAuthenticationRequiredError = exports.LoopDetectedError = exports.InternalServerError = exports.InsufficientStorageError = exports.GatewayTimeoutError = exports.BandwithLimitExceededError = exports.BadGatewayError = void 0;
const BaseError_1 = require("./BaseError");
const ErrorCodes_1 = require("./ErrorCodes");
class BadGatewayError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.BadGatewayError, message);
    }
}
exports.BadGatewayError = BadGatewayError;
class BandwithLimitExceededError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.BandwithLimitExceededError, message);
    }
}
exports.BandwithLimitExceededError = BandwithLimitExceededError;
class GatewayTimeoutError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.GatewayTimeoutError, message);
    }
}
exports.GatewayTimeoutError = GatewayTimeoutError;
class InsufficientStorageError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.InsufficientStorageError, message);
    }
}
exports.InsufficientStorageError = InsufficientStorageError;
class InternalServerError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.InternalServerError, message);
    }
}
exports.InternalServerError = InternalServerError;
class LoopDetectedError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.LoopDetectedError, message);
    }
}
exports.LoopDetectedError = LoopDetectedError;
class NetworkAuthenticationRequiredError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.NetworkAuthenticationRequiredError, message);
    }
}
exports.NetworkAuthenticationRequiredError = NetworkAuthenticationRequiredError;
class NotImplementedError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.NotImplementedError, message);
    }
}
exports.NotImplementedError = NotImplementedError;
class ServiceUnavaliableError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.ServiceUnavaliableError, message);
    }
}
exports.ServiceUnavaliableError = ServiceUnavaliableError;
class VersionNotSupportedError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.VersionNotSupportedError, message);
    }
}
exports.VersionNotSupportedError = VersionNotSupportedError;
//# sourceMappingURL=ServerErrors.js.map